import React from 'react';
import { Form, Input } from 'antd';
import { NumberOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { t } from "@lingui/core/macro";
import { useFormPath } from './index';

export default (formPlugin, namespace) => {
    return {
        Renderer: (props) => {

            const { listFieldProps, buildName } = useFormPath()

            if (props.remove) {
                formPlugin.onAddFormPlugin(props, props.nodeId, props.pluginConfig.id)
            }

            if ((props.isPreviewMode || props.readOnly) && !props.data.fieldKey) {
                return null
            }

            const { data } = props

            let tooltip = null
            if (data.tooltip) {
                tooltip = {
                    title: data.tooltip,
                    icon: <InfoCircleOutlined />,
                }
            }

            const finalName = "[SOCIAL_ID]_" + data.fieldKey

            return (
                <Form.Item
                    {...(listFieldProps || {})}
                    label={`${data.label || t`Numéro d’identité`} :`}
                    name={buildName(finalName)}
                    rules={[{ required: data.required || false, message: t`Ce champ est obligatoire` }]}
                    tooltip={tooltip}
                >
                    <Input placeholder={data.placeholder} />
                </Form.Item>
            )
        },
        namespace: namespace,
        id: 'form-contact-social_id' + namespace,
        title: t`Numéro d’identité`,
        description: t`Élément de formulaire utilisable.`,
        icon: <NumberOutlined />,
        iconColor: "#F39C12",
        version: 1,
        controls: {
            type: 'autoform',
            schema: {
                properties: {
                    required: {
                        type: 'boolean',
                        uniforms: {
                            label: t`Obligatoire`,
                        }
                    },
                    fieldKey: {
                        type: 'string',
                        uniforms: {
                            required: true,
                            label: t`Identifiant`,
                            placeholder: t`Identifiant du champ`,
                        }
                    },
                    label: {
                        type: 'string',
                        uniforms: {
                            label: t`Étiquette`,
                            placeholder: t`Libellé`,
                        }
                    },
                    placeholder: {
                        type: 'string',
                        uniforms: {
                            label: t`Sous-Étiquette`,
                            placeholder: t`Sous-Étiquette`,
                        }
                    },
                    tooltip: {
                        type: 'string',
                        uniforms: {
                            label: t`Message d'aide`,
                            placeholder: t`Message d'aide`,
                            multiline: true,
                            rows: 2,
                        }
                    }
                }
            },
        },
    }
}
